"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClayTooltipProvider = void 0;
var _shared = require("@clayui/shared");
var _react = _interopRequireWildcard(require("react"));
var _warning = _interopRequireDefault(require("warning"));
var _Tooltip = require("./Tooltip");
var _useAlign = require("./useAlign");
var _useClosestTitle2 = require("./useClosestTitle");
var _useTooltipState2 = require("./useTooltipState");
var _excluded = ["type"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var initialState = {
  align: 'top',
  floating: false,
  setAsHTML: false,
  title: ''
};
var TRIGGER_HIDE_EVENTS = ['dragstart', 'mouseout', 'mouseup', 'pointerup', 'touchend'];
var TRIGGER_SHOW_EVENTS = ['mouseover', 'mouseup', 'pointerdown', 'touchstart'];
var reducer = function reducer(state, _ref) {
  var type = _ref.type,
    payload = _objectWithoutProperties(_ref, _excluded);
  switch (type) {
    case 'update':
      return _objectSpread(_objectSpread({}, state), payload);
    case 'reset':
      return _objectSpread(_objectSpread({}, state), {}, {
        align: initialState.align,
        floating: false
      });
    default:
      throw new TypeError();
  }
};
var ClayTooltipProvider = exports.ClayTooltipProvider = function ClayTooltipProvider(_ref2) {
  var _ref2$autoAlign = _ref2.autoAlign,
    autoAlign = _ref2$autoAlign === void 0 ? true : _ref2$autoAlign,
    children = _ref2.children,
    _ref2$containerProps = _ref2.containerProps,
    containerProps = _ref2$containerProps === void 0 ? {} : _ref2$containerProps,
    _ref2$contentRenderer = _ref2.contentRenderer,
    contentRenderer = _ref2$contentRenderer === void 0 ? function (props) {
      return props.title;
    } : _ref2$contentRenderer,
    _ref2$delay = _ref2.delay,
    delay = _ref2$delay === void 0 ? 600 : _ref2$delay,
    scope = _ref2.scope;
  var _useReducer = (0, _react.useReducer)(reducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    _useReducer2$ = _useReducer2[0],
    align = _useReducer2$.align,
    floating = _useReducer2$.floating,
    setAsHTML = _useReducer2$.setAsHTML,
    _useReducer2$$title = _useReducer2$.title,
    title = _useReducer2$$title === void 0 ? '' : _useReducer2$$title,
    dispatch = _useReducer2[1];
  var tooltipRef = (0, _react.useRef)(null);
  var _useInteractionFocus = (0, _shared.useInteractionFocus)(),
    getInteraction = _useInteractionFocus.getInteraction,
    isFocusVisible = _useInteractionFocus.isFocusVisible;
  var isHovered = (0, _react.useRef)(false);
  var isFocused = (0, _react.useRef)(false);
  var _useTooltipState = (0, _useTooltipState2.useTooltipState)({
      delay: delay
    }),
    close = _useTooltipState.close,
    isOpen = _useTooltipState.isOpen,
    open = _useTooltipState.open;
  var _useClosestTitle = (0, _useClosestTitle2.useClosestTitle)({
      forceHide: (0, _react.useCallback)(function () {
        dispatch({
          type: 'reset'
        });
        close();
      }, []),
      onClick: (0, _react.useCallback)(function () {
        isFocused.current = false;
        isHovered.current = false;
      }, []),
      onHide: (0, _react.useCallback)(function () {
        if (!isHovered.current && !isFocused.current) {
          dispatch({
            type: 'reset'
          });
          close();
        }
      }, []),
      tooltipRef: tooltipRef
    }),
    forceHide = _useClosestTitle.forceHide,
    getProps = _useClosestTitle.getProps,
    onHide = _useClosestTitle.onHide,
    target = _useClosestTitle.target,
    titleNode = _useClosestTitle.titleNode;
  (0, _useAlign.useAlign)({
    align: align,
    autoAlign: autoAlign,
    floating: floating,
    isOpen: isOpen,
    onAlign: (0, _react.useCallback)(function (align) {
      return dispatch({
        align: align,
        type: 'update'
      });
    }, []),
    sourceElement: tooltipRef,
    targetElement: titleNode,
    title: title
  });
  var onShow = (0, _react.useCallback)(function (event) {
    if (isHovered.current || isFocused.current) {
      var _props = getProps(event, isHovered.current);
      if (_props) {
        var _ref3;
        dispatch({
          align: (_ref3 = _props.align) !== null && _ref3 !== void 0 ? _ref3 : align,
          floating: _props.floating,
          setAsHTML: _props.setAsHTML,
          title: _props.title,
          type: 'update'
        });
        open(isFocused.current, _props.delay ? Number(_props.delay) : undefined);
      }
    }
  }, [align]);
  (0, _react.useEffect)(function () {
    var handleEsc = function handleEsc(event) {
      if (isOpen && event.key === _shared.Keys.Esc) {
        event.stopImmediatePropagation();
        forceHide();
      }
    };
    document.addEventListener('keyup', handleEsc, true);
    return function () {
      return document.removeEventListener('keyup', handleEsc, true);
    };
  }, [isOpen]);
  var onHoverStart = function onHoverStart(event) {
    if (getInteraction() === 'pointer') {
      isHovered.current = true;
    } else {
      isHovered.current = false;
    }
    onShow(event);
  };
  var onHoverEnd = function onHoverEnd(event) {
    isFocused.current = false;
    isHovered.current = false;
    onHide(event);
  };
  var onFocus = function onFocus(event) {
    if (isFocusVisible()) {
      isFocused.current = true;
      onShow(event);
    }
  };
  var onBlur = function onBlur(event) {
    isFocused.current = false;
    isHovered.current = false;
    onHide(event);
  };
  (0, _react.useEffect)(function () {
    if (scope) {
      var disposeShowEvents = TRIGGER_SHOW_EVENTS.map(function (eventName) {
        return (0, _shared.delegate)(document.body, eventName, scope, onHoverStart);
      });
      var disposeHideEvents = TRIGGER_HIDE_EVENTS.map(function (eventName) {
        return (0, _shared.delegate)(document.body, eventName, "".concat(scope, ", .tooltip"), onHoverEnd);
      });
      var disposeShowFocus = (0, _shared.delegate)(document.body, 'focus', "".concat(scope, ", .tooltip"), onFocus, true);
      var disposeCloseBlur = (0, _shared.delegate)(document.body, 'blur', "".concat(scope, ", .tooltip"), onBlur, true);
      return function () {
        disposeShowEvents.forEach(function (_ref4) {
          var dispose = _ref4.dispose;
          return dispose();
        });
        disposeHideEvents.forEach(function (_ref5) {
          var dispose = _ref5.dispose;
          return dispose();
        });
        disposeShowFocus.dispose();
        disposeCloseBlur.dispose();
      };
    }
  }, [onShow]);
  "production" !== "production" ? (0, _warning.default)(typeof children === 'undefined' && typeof scope !== 'undefined' || typeof scope === 'undefined' && typeof children !== 'undefined', '<TooltipProvider />: You must use at least one of the following props: `children` or `scope`.') : void 0;
  "production" !== "production" ? (0, _warning.default)(typeof children !== 'undefined' || typeof scope !== 'undefined', '<TooltipProvider />: If you want to use `scope`, use <TooltipProvider /> as a singleton and do not pass `children`.') : void 0;
  "production" !== "production" ? (0, _warning.default)((children === null || children === void 0 ? void 0 : children.type) !== _react.default.Fragment, '<TooltipProvider />: React Fragment is not allowed as a child to TooltipProvider. Child must be a single HTML element that accepts `onMouseOver` and `onMouseOut`.') : void 0;
  var titleContent = contentRenderer({
    targetNode: target.current,
    title: title
  });
  var tooltip = isOpen && /*#__PURE__*/_react.default.createElement(_shared.ClayPortal, containerProps, /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    alignPosition: align,
    ref: tooltipRef,
    show: true
  }, setAsHTML && typeof titleContent === 'string' ? /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: titleContent
    }
  }) : titleContent));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, scope ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, tooltip, children) : children && /*#__PURE__*/_react.default.cloneElement(children, _objectSpread(_objectSpread({}, children.props), {}, {
    children: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children.props.children, tooltip),
    onBlur: onBlur,
    onFocus: onFocus,
    onMouseOut: onHoverEnd,
    onMouseOver: onHoverStart
  })));
};